import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useQuery } from 'react-query';

function useGetLessonIssues(data = {}) {
  const { enabled = false, config = {}, queryKey = ['lesson-issues'] } = data;
  const { params = {} } = config;
  const { privateFetch } = useContext(FetchContext);

  const fetchIssues = () => privateFetch.get('/v1/admin/lesson-issues', { params });

  return useQuery(queryKey, fetchIssues, {
    enabled,
    keepPreviousData: true,
  });
}

export default useGetLessonIssues;
